<template>
    <td v-bind="$attrs" v-on="$listeners">
        <slot v-bind="attrs">
            <slot name="before-content" v-bind="attrs">
                <oc-plugin-slot name="row-cell-before-content" v-bind="attrs" ref="beforeContent" />
            </slot>

            <oc-plugin-slot name="row-cell-content" v-bind="$props">
                <template v-if="escapeContent">{{content}}</template>
                <span v-else v-html="content" />
            </oc-plugin-slot>

            <slot name="after-content" v-bind="attrs">
                <oc-plugin-slot name="row-cell-after-content" v-bind="attrs" ref="afterContent" />
            </slot>
        </slot>
    </td>
</template>

<script>
export default {
    name: 'oc-table-cell',
    props: {
        field: {},
        content: {},
        escapeContent: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        attrs() {
            return Object.assign({}, this.$props, this.$attrs)
        }
    }
}
</script>
